import { DisplayObject } from "@pixi/display";
DisplayObject.prototype.renderCanvas = function(_renderer) {
};
//# sourceMappingURL=DisplayObject.mjs.map
